export const EmailIcon = () => (
    <img className='w-full h-full object-contain' src={`${window.location.origin}/icons/28px_ContactSales.svg`} alt="Contact Sales" />
);
